import React from "react";

const HeaderViewBanner = ({
  profile,
  inperosnate,
  inperosnateDetail,
  viewingCompanyName,
  onExit,
  t,
}) => {
  if (inperosnate && inperosnateDetail) {
    const label = `${t("commonComponent.adminTitleText")} ${inperosnateDetail.company.name} ${t("commonComponent.asText")} ${inperosnateDetail.name}`;

    return (
      <div className="header-view-banner" role="status" title={label}>
        <span className="header-view-banner-text">{label}</span>
        <button
          type="button"
          className="header-view-banner-exit"
          onClick={onExit}
        >
          {t("commonComponent.Exit")}
        </button>
      </div>
    );
  }

  if (profile && profile.role === 3 && viewingCompanyName) {
    const label = `${t("commonComponent.adminTitleText")} ${viewingCompanyName}`;
    return (
      <div className="header-view-banner header-view-banner-admin" role="status" title={label}>
        <span className="header-view-banner-text">{label}</span>
      </div>
    );
  }

  return null;
};

export default HeaderViewBanner;
